import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  agentInfo: null,
};

const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    setAgentInfo: (state, action) => {
      state.agentInfo = action.payload;
    },
    logoutAgent: (state) => {
      state.agentInfo = null; // Clear agent info on logout
    },
  },
});

export const { setAgentInfo, logoutAgent } = agentSlice.actions;
export default agentSlice.reducer;
